import { PageTitle } from "Components/Titles";
import { Container } from "semantic-ui-react";
import { UpdateCompany } from "Features/Company";
import { useTranslation } from "react-i18next";

function EditCompany () {

    const { t } = useTranslation();

    return (
        <Container className="page">
            <PageTitle title={t("pages.editCompany")} />
            <UpdateCompany />
        </Container>
    );
}

export default EditCompany;